module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e13e65"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e165"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c2_r1",
      "id": "d12e166"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e168"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c3_r1#d12e100",
      "id": "d12e169"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e177"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c5_r1#d12e289",
      "id": "d12e178"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e180"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c6_r1#d12e297",
      "id": "d12e181"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e183"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c7_r1#d12e538",
      "id": "d12e184"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e186"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c8_r1#d12e966",
      "id": "d12e187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e189"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c9_r1#d12e1442",
      "id": "d12e190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e192"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c10_r1#d12e1723",
      "id": "d12e193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e195"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c11_r1#d12e2069",
      "id": "d12e196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e199"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c12_r1#d12e2321",
      "id": "d12e200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e202"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c13_r1#d12e2331",
      "id": "d12e203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e205"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_cc13_r1#d12e2813",
      "id": "d12e206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e208"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c14_r1#d12e3103",
      "id": "d12e209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e211"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c15_r1#d12e3452",
      "id": "d12e212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e214"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c16_r1#d12e3765",
      "id": "d12e215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e217"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c17_r1#d12e4072",
      "id": "d12e218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e220"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c17.1_r1#d12e4257",
      "id": "d12e221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e223"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c18_r1#d12e4479",
      "id": "d12e224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e226"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c19_r1#d12e4487",
      "id": "d12e227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e229"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c21_r1#d12e4697",
      "id": "d12e230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e233"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c22_r1#d12e4932",
      "id": "d12e234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e236"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c23_r1#d12e5254",
      "id": "d12e237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e239"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c24_r1#d12e5484",
      "id": "d12e240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e242"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c25_r1#d12e5798",
      "id": "d12e243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e245"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c26_r1#d12e5806",
      "id": "d12e246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e248"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c27_r1#d12e6059",
      "id": "d12e249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e251"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c28_r1#d12e6328",
      "id": "d12e252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e254"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c29_r1#d12e6450",
      "id": "d12e255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e257"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c30_r1#d12e6550",
      "id": "d12e258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e260"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c31_r1#d12e6788",
      "id": "d12e261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e263"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c31w_r1#d12e6935",
      "id": "d12e264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e267"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c32_r1#d12e7081",
      "id": "d12e268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e270"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c33_r1#d12e7322",
      "id": "d12e271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be sure to read this excerpt from the next book n the Singing River Series, The Courtship")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e273"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c34_r1#d12e7678",
      "id": "d12e274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three ways to keep up on your favorite Zondervan books and authors")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e276"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_cd34_r1#d12e7706",
      "id": "d12e277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "cpt",
    attrs: {
      "id": "d12e279"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_cf34_r1#d12e7714",
      "id": "d12e280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Share Your Thoughts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-520af7c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Morr_9780310252344_epub_c3d_r1.vue
// module id = 72
// module chunks = 0